import { type TSalesReportQueryParams } from 'features/accounting/sales-report/types';
import {
  type SHIFT_CLOSING_LOCK_STATUS,
  type TAccountingPagingParams,
  type TICKET_STATUS_KEYWORD,
} from 'features/accounting/types';

/**
 * Types and enums for Accounting - Debts (Công nợ)
 */

export enum DEBT_DATA_TYPE {
  SALES = 'sales',
  REFUNDS = 'refunds',
}

export enum DEBT_SERVICE_TYPE {
  AIRLINES = 'airlines',
  HOTELS = 'hotels',
  ATTRACTIONS = 'attractions',
  INSURANCE = 'insurance',
}

export enum DEBT_REPORT_GROUP {
  RECEIVABLES = 'receivables',
  PAYABLES = 'payables',
}

export enum RECEIVABLE_REPORT_KEY {
  SALES_REPORT = 'sales-report',
  TRANSACTION_REPORT = 'transaction-report',
  DEBT_REPORT = 'debt-report',
}

export enum PAYABLE_REPORT_KEY {
  PROVIDER_TOPUP = 'provider-topup',
  DEBT_REPORT = 'debt-report',
}

export type TDebtReportKey = RECEIVABLE_REPORT_KEY | PAYABLE_REPORT_KEY;

export enum RECONCILIATION_STEP {
  IMPORT = 1,
  VERIFY = 2,
  // eslint-disable-next-line no-magic-numbers
  DATA_PROCESSING = 3,
  /** @deprecated Use VERIFY instead */
  VERIFY_AND_PROCESS = 2,
}

export type TReconciliationStep = RECONCILIATION_STEP;

export enum DATA_PROCESSING_STEP_TYPE {
  IMPORT = 'import',
  RECONCILIATION = 'reconciliation',
  PROCESSING = 'processing',
}

export enum DATA_IMPORT_TYPE {
  SALES = 'sales',
  PROVIDERS = 'providers',
  BANK = 'bank',
  TRANSACTION_REPORT = 'transaction-report',
}

/** Payload of `buildPendingDebtFilterRequestParams`. */
export type TBuildPendingDebtFilterRequestParamsPayload = {
  /** URL query params (the sales report filter keys). */
  queryParams: TSalesReportQueryParams;
  /** Ticket status forced by the data tab (refunds), overriding the "Loại vé" filter. */
  fixedStatus?: TICKET_STATUS_KEYWORD;
  /** Lock state of the listed tickets; defaults to the pending data (`PENDING`). */
  lockStatus?: SHIFT_CLOSING_LOCK_STATUS;
};

/** Payload of `buildPendingDebtRequestParams`. */
export type TBuildPendingDebtRequestParamsPayload =
  TBuildPendingDebtFilterRequestParamsPayload & {
    pagination: TAccountingPagingParams;
  };

/** Counts shown by the success message of a data comparison (`buildCompareSuccessMessage`). */
export type TCompareSuccessCounts = {
  matchedCount: number;
  unmatchedCount: number;
  /** Unconfirmed tickets, only counted by the airline comparison. */
  unconfirmedCount?: number;
};
